module.exports = __webpack_public_path__ + "img/disabled-add.30945f57.svg";